import { ApiService as api } from '@/services/axiosHelper';

export default new (class CustomerService {
	constructor() {}

	async UpdateFavorite(payload) {
		return await api.post('/favorite', payload);
	}

	async VueLoginBypass(payload) {
		let email = Array.isArray(payload.email)? payload.email[0]: payload.email;
		Object.assign(payload, { email : email}); 
		return await api.post('/vueloginbypass', payload);
	}
})();
